import Monitor from '@fe/monitor';
import { env, isBrowser } from '@web3/base-utils';

const { hasOwnProperty } = Object.prototype;

const isValidResponse = (data: Record<string, unknown>): boolean => {
  const hasReturnCode =
    hasOwnProperty.call(data, 'ret_code') ||
    hasOwnProperty.call(data, 'retCode');
  const hasMessage =
    hasOwnProperty.call(data, 'ret_msg') || hasOwnProperty.call(data, 'retMsg');
  const hasResult = hasOwnProperty.call(data, 'result');
  return hasReturnCode && hasMessage && hasResult;
};

enum RESPONE_ERROR {
  EMPTY_RESPONE = 1e9,
  UNKNOWN_ERROR = 9e9,
}

let monitor: Monitor;

export async function monitorInit() {
  if (!isBrowser) return;

  // 非微前端架构，初始化monitor
  monitor = new Monitor();

  const envMap: { [key: string]: 'dev' | 'sitnet' | 'testnet' | 'mainnet' } = {
    dev: 'sitnet',
    testnet: 'testnet',
    mainnet: 'mainnet',
  };
  monitor.init({
    env: envMap[env],
    release: '1.0.0',
    onResponse(data: any) {
      if (typeof data === 'string') {
        return data ? 0 : RESPONE_ERROR.EMPTY_RESPONE;
      }
      if (!data) {
        return RESPONE_ERROR.EMPTY_RESPONE;
      }
      if (
        !isValidResponse(data) ||
        data?.ret_code === 0 ||
        data?.retCode === 0
      ) {
        return 0;
      }

      return (data?.ret_code ??
        data?.retCode ??
        RESPONE_ERROR.UNKNOWN_ERROR) as number;
    },
  });
}

export const monitorLog = (params: Parameters<Monitor['log']>[0]) => {
  return monitor?.log?.(params);
};
